import { useQuery } from '@tanstack/react-query';
import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { useEffect } from 'react';
import { useToast } from '@pw-tech/omni-ui';
import { getErrorMessage } from '@/modules/common/utils';
import { ApiClient } from '@pw-tech/web-sdk';

export const useGetAllCourses = ({ enabled = true }: { enabled?: boolean }) => {
  const { toast: showToaster } = useToast();

  const { data, error, isFetching, isLoading, refetch } = useQuery<any>({
    queryKey: [API_CACHE_KEYS.GET_ALL_COURSES],
    queryFn: () => ApiClient.get(API_PATHS.GET_ALL_COURSES),
    enabled,
  });

  useEffect(() => {
    if (error) {
      const errorMessage = getErrorMessage(error, 'Error in fetching courses data');
      showToaster({
        message: errorMessage,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }
  }, [error]);

  return {
    data: data?.data || null,
    error,
    isFetching,
    isLoading,
    refetch,
  };
};
